import DataWorker from 'workerize-loader!./worker'; // eslint-disable-line import/no-webpack-loader-syntax

export default DataWorker